import React, { useMemo } from "react";
import { ReactifyChartColors } from "Util/ReactifyChartColors";

const colors = ReactifyChartColors();

import Chart from "react-apexcharts";

function AreaChart() {
  const { options, series } = useMemo(
    () => ({
      options: {
        colors: [colors.ReactifyChartColor1],
        chart: {
          id: "basic-line"
        },
        xaxis: {
          categories: [2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019]
        }
      },
      responsive: [
        {
          breakpoint: 1000,
          options: {
            plotOptions: {
              bar: {
                horizontal: false
              }
            }
          }
        }
      ],
      series: [
        {
          name: "Sales",
          data: [30, 40, 45, 50, 49, 60, 70, 91]
        }
      ]
    }),
    []
  );

  return (
    <Chart options={options} series={series} type="area" width="100%" />
  );
}

export default AreaChart;
